import React, { useState } from "react";
import ModalWrapper from "./ModalWrapper";
import H2RInput from "../../H2RComponents/H2RInput";
import H2RButton from "../../H2RComponents/H2RButton";

import * as cuesApi from "../../../api/cue";
import { TextArea } from "../FormElements";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

export default function AddSocialCommentModal({ open, dataSourceId, onClose }) {
	const [name, setName] = useState("");
	const [comment, setComment] = useState("");
	const [url, setUrl] = useState("");

	const handleAddMessage = () => {
		if (!name || !comment) return null;

		let messageObject = {
			id: new Date().getTime(),
			timestamp: new Date().getTime(),
			snippet: {
				displayMessage: comment,
			},
			authorDetails: {
				displayName: name,
				profileImageUrl: url,
			},
			listed: true,
			// platform: {
			// 	name: "YouTube",
			// 	logoUrl: "https://img.url.com",
			// },
		};

		cuesApi.addDataSourceMessage(dataSourceId, [messageObject]);

		setName("");
		setComment("");
		return onClose();
	};

	console.log('AddSocialCommentModal', open)

	return (
		<ModalWrapper open={open} onClose={onClose} closeable={true}>
			<div className="flex flex-col space-y-2">
				<H2RInput
					value={name}
					onChange={(change) => setName(change)}
					label="Name"
					placeholder="John Barker"
				/>
				<TextArea
					value={comment}
					onChange={(change) => setComment(change)}
					label="Comment"
					placeholder="Here is a great comment to add..."
				/>
				<H2RInput
					value={url}
					onChange={(change) => setUrl(change)}
					label="Profile image URL (optional)"
					placeholder="https://h2r.graphics/img/..."
				/>
				<span></span>
				<H2RButton
					onClick={handleAddMessage}
					icon={faPlus}
					text="Add custom comment"
					size="small"
				/>
			</div>
		</ModalWrapper>
	);
}
